import {AxiosError} from 'axios';

import {BrowserErrorDTO, Completable, KashableResponseDTO} from 'kashable-mobile-common';

import {errored, mapSucceeded} from '../utils/AxiosUtils';

import axios from './base';

const exceptionHandler = (dto: BrowserErrorDTO): Promise<Completable<boolean>> => {
    return axios
        .post<KashableResponseDTO<boolean>>('/secured/user/error', dto)
        .then((res) => mapSucceeded(res, (d) => d.data))
        .catch((error: AxiosError<string>) => errored(error));
};

export {exceptionHandler};
